import api from '../../lib/api';
import type {
  Supplier,
  SupplierEvaluation,
  SupplierEvaluationPayload,
  SupplierListParams,
  SupplierListResponse,
  SupplierPayload,
} from './types';

export const fetchSuppliers = async (params: SupplierListParams = {}): Promise<SupplierListResponse> => {
  const { data } = await api.get<SupplierListResponse>('suppliers', { params });
  return data;
};

export const fetchSupplier = async (id: string): Promise<Supplier> => {
  const { data } = await api.get<Supplier>(`suppliers/${id}`);
  return data;
};

export const createSupplier = async (payload: SupplierPayload): Promise<Supplier> => {
  const { data } = await api.post<Supplier>('suppliers', payload);
  return data;
};

export const updateSupplier = async (id: string, payload: SupplierPayload): Promise<Supplier> => {
  const { data } = await api.put<Supplier>(`suppliers/${id}`, payload);
  return data;
};

export const deactivateSupplier = async (id: string): Promise<Supplier> => {
  const { data } = await api.delete<Supplier>(`suppliers/${id}`);
  return data;
};

export const fetchEvaluations = async (supplierId: string): Promise<SupplierEvaluation[]> => {
  const { data } = await api.get<SupplierEvaluation[]>(`suppliers/${supplierId}/evaluations`);
  return data;
};

export const createEvaluation = async (
  supplierId: string,
  payload: SupplierEvaluationPayload,
): Promise<SupplierEvaluation> => {
  const { data } = await api.post<SupplierEvaluation>(`suppliers/${supplierId}/evaluations`, payload);
  return data;
};
